import { useGetConstellationsResultsQuery } from 'api/ConstellationResultEndPoints';
import TopConfig from 'modules/Dashboard/TopConfig';
import { useMemo } from 'react';
import Loader from 'shared/component/Loader';
import { Statistics } from 'shared/model/statistic.model';

type Props = {
  stats?: Statistics;
};

const TopConfigs = ({ stats }: Props) => {
  const { data, isLoading } = useGetConstellationsResultsQuery({
    include: ['constellationConfiguration'],
    where: {
      id: {
        inq: stats?.topConfigs.map(a => a.resultId),
      },
    },
  });

  const results = data ?? [];

  const tops = useMemo(() => {
    if (!stats) return [];
    return stats.topConfigs.map(config => {
      const result = {
        ...config,
      };
      const found = results.find(r => r.id === config.resultId);
      if (found?.constellationConfiguration?.name) {
        result.name = found.constellationConfiguration.name;
      }
      return result;
    });
  }, [stats, results]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div>
      {tops.map(item => {
        return <TopConfig key={item.resultId} item={item} />;
      })}
    </div>
  );
};

export default TopConfigs;
